import React from 'react';
import styled from 'styled-components';
import { textFieldBaseStyles } from '../HBTextField/HBTextField.styles';
import { INPUT_SIZE_PROPS } from '../HBTextField/variables';
import {
    flexCenterVertical,
    printCss,
    showInPrintOnly,
    truncatedText
} from '../../styles/mixins';
import { HBInputProps } from '../HBInput/HBInput.types';

// Due to a problem with input text alignment, this is a solution for pdf printing.

const MockPrintInput = (props: HBInputProps) => {
    return (
        <MockInput inputProps={props}>
            <InputText>{props.value || props.placeholder || ''}</InputText>
        </MockInput>
    );
};

export default MockPrintInput;

// -------------------------------- Styles -------------------------------- //
const MockInput = styled.div<{ inputProps: HBInputProps }>`
    ${flexCenterVertical}

    ${props => textFieldBaseStyles(props.inputProps)}
    ${props => INPUT_SIZE_PROPS[props.inputProps.scope][props.inputProps.size]};
    ${showInPrintOnly('flex')};
`;

const InputText = styled.span`
    ${printCss(`
        ${truncatedText};
    `)}
`;
